import { isServer } from '@tanstack/react-query';
import { withDefaults } from './defaultEnv';
import { getEnvironmentServer } from './envServer';

export type Env = {
  GIT_REF?: string;
  DEPLOYMENT_MODE: 'self-hosted' | 'saas';
  // comma divided list of login modes (password,microsoft)
  LOGIN_MODES: string;
  NEXT_PUBLIC_API_URL: string;
  NEXT_PUBLIC_AUTH_API_URL: string;
  NEXT_PUBLIC_OAUTH_API_URL: string | undefined;
  NEXT_PUBLIC_AUTH0_AUDIENCE: string;
  NEXT_PUBLIC_AUTH0_CLIENT_ID: string;
  NEXT_PUBLIC_AUTH0_DOMAIN: string;
  NEXT_PUBLIC_AUTH0_SCOPE: string;
  NEXT_PUBLIC_AUTH_MODE: 'auth0' | string;
  NEXT_PUBLIC_SENTRY_ENVIRONMENT?: 'dev' | 'prod';
  NEXT_PUBLIC_ENABLE_TRANSLATIONS?: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_CONVERSATIONS: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_LLM_ISSUES_V2: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_BETA_FEATURES: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_ADD_MEMBER: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_AI_SUMMARY: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_USER_PROBLEMS_AI_SUMMARY: 'true' | 'false' | undefined;
  NEXT_PUBLIC_DEFAULT_AGGREGATION: 'interaction' | 'conversation' | undefined;
  MISSING_PROCESSING_WRAPPING_TEXT?: string;
  NEXT_PUBLIC_APP_FAVICON: string | undefined;
  NEXT_PUBLIC_SHOW_FAVICON_SIDEBAR: 'true' | 'false' | undefined;
  NEXT_PUBLIC_APP_TITLE: string | undefined;
  NEXT_PUBLIC_APP_DESCRIPTION: string | undefined;
  CUSTOM_INTENT_CONFIG?: Record<string, string>;
  NEXT_PUBLIC_ENABLE_OLD_RISKY_BEHAVIOR: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_INTERACTIONS_DETAILS_ACCESS_CONTROL: 'true' | 'false' | undefined;
  NEXT_PUBLIC_INTERACTIONS_DETAILS_ACCESS_CONTROL_MODE: 'reason' | 'disabled' | undefined;
  NEXT_PUBLIC_INTERACTIONS_DETAILS_ACCESS_CONTROL_ROLES: string | undefined;
  NEXT_PUBLIC_ENABLE_LLM_ISSUE_HIDING: 'true' | 'false' | undefined;
  NEXT_PUBLIC_GTM_ID: string | undefined;
  NEXT_PUBLIC_LDAP_ENABLED: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_SUB_CATEGORIES: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_AB_TESTING: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_OUT_OF_SCOPE: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_CUSTOM_ACTIVATION_RATE: 'true' | 'false' | undefined;
  HELM_CHART_VERSION: string | undefined;
  NEXT_PUBLIC_PERFORMANCE_MODE: 'true' | 'false' | undefined;
  NEXT_PUBLIC_SHOW_USER_INTELLIGENCE_VIEW_SWITCH: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_COHORTS: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_CUSTOM_VARIABLES: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_USER_ANONYMIZATION: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_REMOTE_ACCESS: 'true' | 'false' | undefined;
  NEXT_PUBLIC_ENABLE_ADMIN_EXPORT_LOGS: 'true' | 'false' | undefined;
  SHOW_TANSTACK_DEVTOOLS?: 'true' | 'false';
  NEXT_URL: string | undefined;
  NEXT_LEGACY_URL: string | undefined;
};

export const getEnvironment = async (): Promise<Env> => {
  let attempt = 0;
  while (attempt < 3) {
    if (isServer) return getEnvironmentServer();
    try {
      return await fetch('/env.json').then(async (res) => {
        return withDefaults(await res.json());
      });
    } catch {
      await new Promise((resolve) => setTimeout(resolve, 500));
      attempt += 1;
    }
  }

  throw new Error('Failed to fetch environment');
};
